<template>
  <div class="property-card">
    <div class="left-column">
      <div class="property-title">{{ propertyTitle }}</div>
    </div>
    <div class="right-column">
      <div class="property-spec">{{ propertySpec }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['propertyTitle', 'propertySpec']
};
</script>

<style lang="scss" scoped>
.property-card {
  width: fit-content;
  border-radius: 6px;
  background-color: #efefef;
  display: flex;
  font-family: Inter;
  font-size: 16px;
  line-height: 24px;
  .left-column,
  .right-column {
    width: 130px;
    padding: 11px 19px;
    text-align: center;
    .property-title {
      font-weight: 400;
      color: #9fa7b6;
    }
    .property-spec {
      font-weight: 500;
      color: #203a54;
    }
  }
  .left-column {
    white-space: nowrap;
    border-right: 1px solid #f3f5fa;
  }
}
</style>
